<template>
      <!-- TRADING SYSTEM CALCULATOR -->
      <card class="col-md-12 col-lg-12" :class="'card-'+theme">
        <div class="card-header">
          <h4 class="card-title">
            <i class="fa fa-calculator"></i> Calculadora de Ordens
            <h5 class="card-title text-danger pull-right">
              *Modo Simulador:
              <l-switch v-model="switches.simulator" type="primary" on-text="ON" off-text="OFF"></l-switch>
            </h5>
          </h4>
        </div>
        <hr />
        <div class="row card-boby">
          <div class="col-md-6">
            <div
              class="row text-center"
              v-if="loadingTradingSystemData"
              v-loading="loadingTradingSystemData"
              id="loading"
            ></div>
            <card
              class="stacked-form"
              v-if="!loadingTradingSystemData"
              :class="'card-catalog-'+theme"
            >
              <form method="#" action="#" @submit.prevent>
                <div>
                  <fg-input
                    label="Banca: $"
                    type="number"
                    step="any"
                    v-model="bankrollEntry"
                    placeholder="Entre com sua Banca"
                  ></fg-input>
                  <fg-input
                    label="Payout: %"
                    type="number"
                    v-model="payoutPercent"
                    placeholder="Entre com o retorno esperado"
                  ></fg-input>
                  <fg-input
                    label="Retorno: %"
                    type="number"
                    step="any"
                    v-model="profitPercent"
                    placeholder="Entre com o retorno esperado"
                  ></fg-input>
                  <div>
                    <p class="card-title">
                      Martingale: {{ switches.martingale ? sliders.martingale : ''}}
                      <l-switch
                        class="pull-right"
                        v-model="switches.martingale"
                        type="primary"
                        on-text="ON"
                        off-text="OFF"
                      ></l-switch>
                    </p>
                    <el-slider
                      class="slider-default"
                      v-if="switches.martingale"
                      :max="6"
                      v-model="sliders.martingale"
                    ></el-slider>
                  </div>
                  <br />
                  <div>
                    <p class="card-title">
                      Mudança de Payout:
                      <l-switch
                        class="pull-right"
                        v-model="payoutContinued"
                        type="azure"
                        on-text="ON"
                        off-text="OFF"
                      ></l-switch>
                    </p>
                  </div>
                  <br />
                  <button
                    type="submit"
                    class="btn btn-round btn-fill"
                    :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                    @click.prevent="calculateOrder()"
                  >Calcular Ordens</button>
                </div>
              </form>
            </card>
          </div>
          <div class="col-md-6" v-if="!switches.simulator">
            <card class="stacked-form" :class="'card-catalog-'+theme">
              <h5 class="card-title text-center">
                Ordens
                <button
                  class="btn btn-round btn-fill"
                  :class=" theme === 'black' ? 'btn-red2':'btn-red' "
                  @click.prevent="cleanOrders()"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </h5>
              <hr />
              <div
                class="row text-center"
                v-if="loadingSaveOrder"
                v-loading="loadingSaveOrder"
                id="loading"
              ></div>
                <h4 class="card-title warning">
                  <small
                    class="text-warning"
                  >Risco da Operação: {{Number.parseFloat(totalRisk+"").toFixed(2)}} %</small>
                </h4>
              <form class="col-md-12" v-if="!loadingSaveOrder">
                <div class="d-flex justify-content-center">
                  <div>
                    <div v-for="(entry, index) in entries" :key="entry.id">
                      <hr />
                      <div class="pull-left">
                        <h5 class="card-title text-left">
                          <template>
                            {{ entry.id }}º Ordem: $ {{ entry.order }}
                            <button
                              class="btn btn-sm"
                              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                              :disabled="!isFirst(entry)"
                              v-clipboard:copy="entry.order"
                              @click.prevent
                            >
                              <i class="nc-icon nc-single-copy-04"></i> Copiar
                            </button>
                          </template>
                          <br />
                          <div
                            :class="isDangerMartingale(entry) ? 'badge btn-danger' : 'badge btn-primary'"
                            v-if="isMartingale(entry)"
                          >{{ entry.id - 1 }}º MG</div>
                          <br />
                          <small>Retorno:</small>
                          $ {{ entry.return }}
                          <br />
                        </h5>
                      </div>
                      <div class="pull-right">
                        <button
                          @click.prevent="doOrder(true)"
                          :disabled="!isFirst(entry)"
                          class="btn btn-green"
                        >
                          WIN {{ entry.win }} %
                          <i class="fas fa-chevron-circle-up"></i>
                        </button>
                        <button
                          @click.prevent="doOrder(false)"
                          :disabled="!isFirst(entry)"
                          class="btn btn-red"
                        >
                          LOSS {{ Number.parseFloat(entry.loss+"").toFixed(2) }} %
                          <i
                            class="fas fa-chevron-circle-down"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </card>
          </div>
          <div class="col-md-6" v-if="switches.simulator">
            <card class="stacked-form" :class="'card-catalog-'+theme">
              <h5 class="card-title text-center">
                <small>Modo Simulador</small> - Ordens
              </h5>
              <hr />
              <h4 class="card-title warning">
                <small
                  class="text-warning"
                >Risco da Operação: {{Number.parseFloat(totalRisk+"").toFixed(2)}} %</small>
              </h4>
              <br />
              <div v-for="(entry, index) in entries" :key="entry.id">
                <h5 class="card-title">
                  <hr />
                  <template>
                    {{ entry.id }}º Ordem: $ {{ entry.order }}
                    <button
                      class="btn-primary btn-sm"
                      v-clipboard:copy="entry.order"
                    >
                      <i class="nc-icon nc-single-copy-04"></i>
                    </button>
                  </template>
                  <br />
                  <div
                    :class="isDangerMartingale(entry) ? 'badge btn-danger' : 'badge btn-primary'"
                    v-if="isMartingale(entry)"
                  >{{ entry.id - 1 }}º MG</div>
                  <br />
                  <small>Retorno:</small>
                  $ {{ entry.return }}
                  <div class="pull-right">
                    <button :disabled="true" class="btn-sm btn-green">
                      WIN {{ entry.win }} %
                      <i class="fas fa-chevron-circle-up"></i>
                    </button>
                    <button :disabled="true" class="btn-sm btn-red">
                      LOSS {{ Number.parseFloat(entry.loss+"").toFixed(2) }} %
                      <i
                        class="fas fa-chevron-circle-down"
                      ></i>
                    </button>
                  </div>
                </h5>
              </div>
            </card>
          </div>
        </div>
        <hr />
        <div class="card-footer text-right">
          <h4 class="card-title">
            <small>*Como o modo simulador, você pode calcular ordens livremente sem salvar esses dados em sua banca.</small>
          </h4>
        </div>
      </card>
</template>

<script>
import Vue from "vue";
import VueTabs from "vue-nav-tabs";
import VueClipboard from "vue-clipboard2";
import {
  Loading,
  Dialog,
  Select,
  Option,
  Slider
} from "element-ui";
import {
  Card,
  Switch as LSwitch,
} from "src/components/index";

Vue.use(Loading.directive, VueTabs);
Vue.use(VueClipboard);

export default {
  name: 'OrdersCalculator',
  components: {
    Card,
    LSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    [Slider.name]: Slider,
    [Dialog.name]: Dialog
  },
  data: () => ({
    orders: [],
    entries: [],
    totalRisk: 0,
    payoutChange: [],
    ordersMessage: "",
    lastWeekOrders: [],
    todaysOrders: [],
    customOrders: [],
    bankroll: 0,
    bankrollEntry: 0,
    depositEntry: 0,
    withdrawEntry: 0,
    weekProfit: 0,
    todayProfit: 0,
    customProfit: 0,
    payoutPercent: 90,
    profitPercent: 1,
    payoutContinued: false,
    loadingTradingSystemData: true,
    loadingSaveOrder: false,
    loadingCustomTradingSystemData: false,
    switches: {
      martingale: false,
      payoutChange: false,
      simulator: false
    },
    sliders: {
      martingale: 3
    },
  }),
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchOrders();
    this.fetchLastWeekOrders();
  },
  methods: {
    fetchLastWeekOrders() {
      this.axios
        .get("/orders/lastweek")
        .then(response => {
          if (response.data.orders) {
            this.lastWeekOrders = response.data.orders;
            this.weekProfit = 0;
            this.lastWeekOrders.map(order => {
              if (order.kind === "order") {
                this.weekProfit += order.bankroll - order.old_bankroll;
              }
            });
            this.weekProfit = Number.parseFloat(this.weekProfit + "").toFixed(
              2
            );
          } else {
            this.weekProfit = 0;
          }
        })
        .catch(error => {
          this.weekProfit = 0;
          console.log(error);
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte" +
              error
          );
        });
    },
    fetchOrders() {
      this.loadingTradingSystemData = true;
      this.axios
        .get("/orders")
        .then(response => {
          this.orders = response.data;
          if (this.orders.length > 0) {
            this.bankroll = this.orders[0].bankroll;
            this.bankrollEntry = this.bankroll;
            this.loadingTradingSystemData = false;
            this.fetchLastWeekOrders();
            this.fetchTodaysOrders();
          } else {
            if (this.$auth.user().subscription) {
              this.notify(
                `Informe um depósito em sua banca para utilizar a calculadora.`
              );
              this.notifyVue("top", "center", "danger", "nc-simple-remove");
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.loadingTradingSystemData = false;
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
              error
          );
        });
    },
    fetchTodaysOrders() {
      this.axios
        .get("/orders/today")
        .then(response => {
          if (response.data.orders) {
            this.todaysOrders = response.data.orders;
            this.todayProfit = 0;
            this.todaysOrders.map(order => {
              if (order.kind === "order") {
                this.todayProfit += order.bankroll - order.old_bankroll;
              }
            });
            this.todayProfit = Number.parseFloat(this.todayProfit + "").toFixed(
              2
            );
          } else {
            this.todayProfit = 0;
          }
        })
        .catch(error => {
          this.todayProfit = 0;
          console.log(error);
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
              error
          );
        });
    },
    cleanOrders() {
      this.switches.martingale = false;
      this.totalRisk = 0;
      this.entries = [];
      this.fetchOrders();
    },
    isMartingale(entry) {
      return entry.id > 1;
    },
    isFirst(entry) {
      return entry.id === this.entries[0].id;
    },
    isDangerMartingale(entry) {
      return entry.id > 3;
    },
    profit() {
      return this.profitPercent / 100;
    },
    payout() {
      return this.payoutPercent / 100;
    },
    lastLossOrZero() {
      const lastEntry = this.entries.slice(-1).pop();
      return lastEntry !== undefined ? lastEntry.loss : 0;
    },
    emptyBankroll() {
      return this.bankroll < 1;
    },
    notify(message) {
      this.ordersMessage = message;
    },
    notifyVue(verticalAlign, horizontalAlign, color, icon) {
      let message = this.ordersMessage;
      this.$notify({
        component: {
          template: `<h5 class="card-title">${message}</h5>`
        },
        icon: "nc-icon " + icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color
      });
    },
    openModal(name) {
      this.depositEntry = 0;
      this.withdrawEntry = 0;
      this.modals[name] = true;
    },
    closeModal(name) {
      this.depositEntry = 0;
      this.withdrawEntry = 0;
      this.modals[name] = false;
    },
    calculateOrder() {
      if (this.payoutContinued == false) {
        this.entries = [];
        while (
          this.entries.length === 0 ||
          (this.switches.martingale &&
            this.entries.length < this.sliders.martingale)
        ) {
          const entry = {};
          entry.id = this.entries.length + 1;
          entry.order = (
            this.bankrollEntry *
            ((this.profit() + this.lastLossOrZero() / 100) / this.payout())
          ).toFixed(2);
          entry.return = (entry.order * this.payout()).toFixed(2);
          entry.profit = this.bankrollEntry * this.profit;
          entry.win = this.profitPercent;
          entry.loss =
            (entry.order / this.bankrollEntry) * 100 + this.lastLossOrZero();
          entry.payout = this.payoutPercent;
          if (entry.loss > 100) {
            break;
          } else {
            this.totalRisk = entry.loss;
          }

          this.entries.push(entry);
        }
      } else {
        if (this.entries.length > 0) {
          if (this.entries[0].id != 1) {
            if (this.entries[0].payout != this.payoutPercent) {
              if (this.entries.length > 0) {
                var payoutPercent = this.payoutPercent;
                var bankrollEntry = this.bankrollEntry;
                var lastLossOrZero = this.lastLossOrZero();
                var previusReturn, previusOrder;
                this.entries.forEach(function(data, index) {
                  if (index > 0) {
                    data.return =
                      parseFloat(previusReturn) + parseFloat(previusOrder);
                    previusReturn = data.return;
                  } else {
                    previusReturn = data.return;
                  }
                  data.order = ((data.return / payoutPercent) * 100).toFixed(2);
                  previusOrder = data.order;
                  data.payout = payoutPercent;
                  data.loss =
                    (data.order / bankrollEntry) * 100 + lastLossOrZero;
                });
                this.totalRisk = this.entries[this.entries.length - 1].loss;
              }
            } else {
              this.payoutContinued = true;
              this.notify(
                `Mudança de Payout: Verifique Se Houve Mudança no Campo Payout!`
              );
              this.notifyVue("top", "center", "danger", "nc-simple-remove");
            }
          } else {
            this.payoutContinued = true;
            this.notify(
              `Mudança de Payout: Nenhuma Ordem Anterior Realizada. Recalcule!`
            );
            this.notifyVue("top", "center", "danger", "nc-simple-remove");
          }
        } else {
          this.payoutContinued = true;
          this.notify(
            `Mudança de Payout: Nenhuma Ordem Para Realizar Mudança. Recalcule!`
          );
          this.notifyVue("top", "center", "danger", "nc-simple-remove");
        }
      }
    },
    doOrder(win) {
      this.loadingSaveOrder = true;
      if (this.bankroll === this.bankrollEntry) {
        const entry = this.entries.shift();
        if (win) this.entries = [];
        this.axios
          .post("/orders?kind=order", { entry, win })
          .then(data => {
            this.notify("Ordem salva com sucesso!");
            this.notifyVue("top", "center", "primary", "nc-check-2");
            this.axios
              .get("/orders")
              .then(response => {
                this.loadingSaveOrder = false;
                this.orders = response.data;
                if (this.orders.length > 0) {
                  this.bankroll = this.orders[0].bankroll;
                  this.bankrollEntry = this.bankroll;
                  this.fetchLastWeekOrders();
                  this.fetchTodaysOrders();
                  if (win) {
                    this.calculateOrder();
                  }
                }
              })
              .catch(error => {
                this.loadingSaveOrder = false;
                console.log(error);
                alert(
                  "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                    error
                );
              });
          })
          .catch(error => {
            console.log(error.message);
            alert(
              "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                error.message
            );
          });
      } else {
        // Init Adjust Loading Here.
        let amount = this.bankrollEntry;
        this.axios
          .post("/orders?kind=adjust", { amount })
          .then(data => {
            const entry = this.entries.shift();
            if (win) this.entries = [];
            this.axios
              .post("/orders?kind=order", { entry, win })
              .then(data => {
                this.loadingSaveOrder = false;
                this.notify("Ordem salva com sucesso!");
                this.notifyVue("top", "center", "primary");
                this.axios
                  .get("/orders")
                  .then(response => {
                    this.orders = response.data;
                    if (this.orders.length > 0) {
                      this.bankroll = this.orders[0].bankroll;
                      this.bankrollEntry = this.bankroll;
                      this.fetchLastWeekOrders();
                      this.fetchTodaysOrders();
                      if (win) {
                        this.calculateOrder();
                      }
                    }
                  })
                  .catch(error => {
                    console.log(error);
                    alert(
                      "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                        error
                    );
                  });
              })
              .catch(res => {
                console.log(error);
                alert(
                  "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                    error
                );
              });
          })
          .catch(res => {
            console.log(error.message);
            alert(
              "Erro ao ajustar banca. Entre em contato com o suporte: " +
                error.message
            );
          });
      }
      if (win == false) {
        this.payoutContinued
          ? (this.payoutContinued = true)
          : (this.payoutContinued = false);
      } else {
        this.payoutContinued = false;
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/OrdersCalculator.vue